import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const required = (key: string): string => {
  const value = process.env[key];
  if (!value && process.env.NODE_ENV === 'development') {
    throw new Error(`Missing required environment variable: ${key}. Check your .env file.`);
  }
  return value || '';
};

const firebaseConfig = {
  apiKey: required('REACT_APP_FIREBASE_API_KEY'),
  authDomain: required('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: required('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: required('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: required('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: required('REACT_APP_FIREBASE_APP_ID'),
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Offline-first: IndexedDB persistence so field assessments survive lost connectivity;
// multi-tab manager keeps several open tabs consistent.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
export const functions = getFunctions(app);
export const storage = getStorage(app);
export default app;
